import { render, staticRenderFns } from "./historyUp.vue?vue&type=template&id=649c19ff"
import script from "./historyUp.vue?vue&type=script&lang=js"
export * from "./historyUp.vue?vue&type=script&lang=js"
import style0 from "./historyUp.vue?vue&type=style&index=0&id=649c19ff&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports